import { trackCtaClick, trackDemoBookingClick, type MarketingCtaLocation } from '../../lib/marketingEvents';
import type { ComparisonTheme } from './comparisonVisualThemes';

const SCHEDULE_DEMO_URL = 'https://meetings.hubspot.com/aditya145';

export interface CTASectionProps {
  headline: string;
  subtext: string;
  pageSlug: string;
  competitorName: string;
  theme: ComparisonTheme;
  location?: MarketingCtaLocation;
}

export default function CTASection({
  headline,
  subtext,
  pageSlug,
  competitorName,
  theme,
  location = 'comparison_cta_section',
}: CTASectionProps) {
  return (
    <section className="relative py-20 lg:py-28 overflow-hidden" style={{ backgroundColor: theme.dark }}>
      <div
        className="pointer-events-none absolute inset-0 opacity-90"
        style={{
          backgroundImage: `${theme.mesh}, linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.35) 100%)`,
        }}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full blur-3xl opacity-30"
        style={{ backgroundColor: theme.primary }}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-32 -left-16 w-[360px] h-[360px] rounded-full blur-3xl opacity-20"
        style={{ backgroundColor: theme.primary }}
        aria-hidden
      />
      <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
        <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-white/50 mb-4">Next step</p>
        <h2 className="text-3xl lg:text-[2.35rem] font-bold text-white leading-tight mb-5 tracking-tight">
          {headline}
        </h2>
        <p className="text-lg text-white/80 mb-10 leading-relaxed">{subtext}</p>
        <a
          href={SCHEDULE_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 px-9 py-4 rounded-2xl text-sm font-semibold bg-white transition-all shadow-xl hover:shadow-2xl hover:-translate-y-0.5"
          style={{ color: theme.primary }}
          onClick={() => {
            trackCtaClick('Book a Demo', location, { page: pageSlug, competitor: competitorName });
            trackDemoBookingClick(location, { page: pageSlug, competitor: competitorName });
          }}
        >
          <i className="ri-calendar-line text-lg" aria-hidden />
          Book a Demo
        </a>
      </div>
    </section>
  );
}
